import axios from 'axios'
import FileSaver from 'file-saver'
import * as XLSX from 'xlsx'
import { isPRD } from '@/utils/obcfg'

const obColor = ['black', 'maroon', 'purple', 'fuchsia', 'green', 'lime', 'olive', 'navy', 'blue', 'teal'][
  Math.floor(Math.random() * 10)
]
function log(...args) {
  if (isPRD) return
  const obStyle = `background:${obColor};font-weight:bold;color:white`
  if (args[0] && /\.load/.test(args[0])) {
    console.log(
      '%c-++-++++=-++---+-=-++++---=-++++--+=-++++-+-=--+-+++-=-++---++=-++-++++=-++-++-+',
      `color:${obColor}`,
    )
  } else {
    console.log('%coblog', obStyle, ...args)
  }
}
function getObj(obj) {
  return JSON.parse(JSON.stringify(obj))
}
function getTS(str) {
  return new Date(str).toLocaleString('zh-CN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  })
}
function getBroFromArr(arr, curKey, curVal, targetKey) {
  for (const item of arr) {
    if (item[curKey] === curVal) {
      return item[targetKey]
    }
  }
  return null
}
function json2fd(obj) {
  const formData = new FormData()
  for (const key in obj) {
    if (Object.hasOwn(obj, key)) {
      formData.append(key, obj[key])
    }
  }
  return formData
}
function mergeArr(arr1, arr2) {
  const mergedSet = new Set([...arr1, ...arr2])
  return [...mergedSet]
}
function isValEmpty(value) {
  return (
    value === null ||
    value === undefined ||
    (typeof value === 'string' && (value.trim() === '' || value.trim() === '{}')) ||
    (Array.isArray(value) && value.length === 0) ||
    (typeof value === 'object' && Object.keys(value).length === 0)
  )
}

function getSlimObj(obj) {
  for (const key in obj) {
    if (Object.hasOwn(obj, key) && isValEmpty(obj[key])) {
      delete obj[key]
    }
  }
  return obj
}
function getValidObj(str) {
  return isValEmpty(str) ? null : JSON.parse(str)
}
function checkConsistency(arr, objt) {
  const obj = arr.reduce((acc, key) => {
    acc[key] = objt[key]
    acc[key + '_'] = objt[key + '_']
    return acc
  }, {})
  /*-++-++++=-++---+-=-++++---=-++++--+=-++++-+-=--+-+++-=-++---++=-++-++++=-++-++-+*/
  if (Object.values(obj).every((value) => value === '')) {
    return true
  }
  /*-++-++++=-++---+-=-++++---=-++++--+=-++++-+-=--+-+++-=-++---++=-++-++++=-++-++-+*/
  const groupedKeys = arr.reduce((acc, key) => {
    acc[key] = [objt[key], objt[key + '_']]
    return acc
  }, {})
  /*-++-++++=-++---+-=-++++---=-++++--+=-++++-+-=--+-+++-=-++---++=-++-++++=-++-++-+*/
  for (const baseKey in groupedKeys) {
    const group = groupedKeys[baseKey]
    const hasValue = group.some((key) => obj[key] !== '')
    if (!hasValue) {
      return false
    }
  }
  return Object.values(groupedKeys).every((group) => group.some((value) => value !== ''))
}
function getCurDate() {
  const today = new Date()
  const year = today.getFullYear()
  const month = String(today.getMonth() + 1).padStart(2, '0')
  const day = String(today.getDate()).padStart(2, '0')
  return year + '-' + month + '-' + day
}
function getCurDateShort() {
  const date = new Date()
  const year = date.getFullYear().toString().slice(-2)
  const month = ('0' + (date.getMonth() + 1)).slice(-2)
  const day = ('0' + date.getDate()).slice(-2)
  return `${year}${month}${day}`
}
function getFirstDayOfYear() {
  const date = new Date()
  const year = date.getFullYear()
  return `${year}-01-01`
}
/*-++-++++=-++---+-=-++++---=-++++--+=-++++-+-=--+-+++-=-++---++=-++-++++=-++-++-+*/
/*-++-++++=-++---+-=-++++---=-++++--+=-++++-+-=--+-+++-=-++---++=-++-++++=-++-++-+*/
function dcsv(url, name) {
  axios
    .get(url, {
      responseType: 'blob',
    })
    .then((res) => {
      const file = new Blob([res.data], { type: 'application/csv' })
      FileSaver.saveAs(file, name ? name : 'tcsv.csv')
    })
}
function gdxls(tableID, fileName) {
  const workbook = XLSX.utils.table_to_book(document.getElementById(tableID))
  try {
    XLSX.writeFile(workbook, fileName ? fileName : 'tdoc.xlsx')
  } catch (e) {
    console.log(e, workbook)
  }
}
function gdcsv(arr, fileName) {
  const worksheet = XLSX.utils.json_to_sheet(arr)
  const wb = XLSX.utils.book_new()
  const sheetName = fileName ? fileName : 'Sheet1'
  XLSX.utils.book_append_sheet(wb, worksheet, sheetName)
  // const csv = '\uFEFF' + XLSX.utils.sheet_to_csv(worksheet)
  // const file = new Blob([csv], { type: 'application/csv;charset=utf-8;' })
  // FileSaver.saveAs(file, fileName ? fileName : 'holy.csv')
  const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
  const file = new Blob([wbout], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8;',
  })
  FileSaver.saveAs(file, `URLB_${fileName}_${getCurDateShort()}.xlsx`)
}

export default {
  log,
  getObj,
  getTS,
  getBroFromArr,
  json2fd,
  mergeArr,
  isValEmpty,
  getSlimObj,
  getValidObj,
  checkConsistency,
  getCurDate,
  getCurDateShort,
  getFirstDayOfYear,
  /*-++-++++=-++---+-=-++++---=-++++--+=-++++-+-=--+-+++-=-++---++=-++-++++=-++-++-+*/
  dcsv,
  gdxls,
  gdcsv,
}
